import { Container, Divider } from "@mui/material";
import { motion } from "framer-motion";
import { useGetHomePageAwardsQuery } from "../../utils/API/features/strapiHomeApi";
import { CustomLoaderType } from "../../utils/constants";
import CustomLoader from "../Shared/CustomLoader/CustomLoader";
import "./DedicatedToQuality.scss";

const DedicatedToQuality = () => {
	const shouldUseStrapi = Boolean(import.meta.env.VITE_STRAPI_URL);

	const {
		data: awards = [],
		isLoading,
		isFetching,
		isError,
	} = useGetHomePageAwardsQuery(undefined, {
		skip: !shouldUseStrapi,
	});

	const isBusy = shouldUseStrapi && (isLoading || isFetching);
	const awardsToRender = !isBusy && !isError && awards.length > 0 ? awards : [];

	if (!isBusy && awardsToRender.length === 0) return null;

	return (
		<Container>
			<Divider />
			<div className='dedicated-quality-wrapper'>
				<motion.div
					initial={{ opacity: 0, x: -50, y: -30 }}
					whileInView={{ opacity: 1, x: 0, y: 0 }}
					viewport={{ once: true, amount: 0.8 }}
					transition={{ ease: "easeOut", duration: 0.4 }}
					className='top-header'
				>
					<p>Our Awards & Achievements</p>
					<h1>Excellence in Service and Dedication to Quality</h1>
				</motion.div>
				<div className='carts-wrapper'>
					{isBusy ? (
						<CustomLoader type={CustomLoaderType.SMALL} />
					) : (
						awardsToRender.map((award, index) => (
							<div className='cart' key={index}>
								<img
									src={award.src}
									style={{
										marginTop: index === 0 || index === 2 || index === 3 ? "30px" : "20px",
									}}
									alt='logo'
								/>
								<p>{award.name}</p>
							</div>
						))
					)}
				</div>
			</div>
		</Container>
	);
};

export default DedicatedToQuality;
